import { TableCell } from "@mui/material";
import {
  TableCell as TableCellProps,
  ButtonCell,
  TableCellType,
  BadgeCell,
} from "../or-table.type";
import {
  AtButton,
  AtButtonSize,
  AtButtonType,
  AtIcon,
  AtTag,
} from "../../../atoms";

interface TableCellRendererProps {
  cell: TableCellProps;
  className?: string;
}

export const TableCellRenderer = ({
  cell,
  className,
}: TableCellRendererProps) => {
  const baseClassName = `!text-sm !font-regular ${className || ""}`;

  const renderCellContent = () => {
    switch (cell.type) {
      case TableCellType.ORIGIN: {
        const bgColor =
          cell.origin.type === "connect" ? "bg-primary-75" : "bg-orange-75";
        const textColor =
          cell.origin.type === "connect"
            ? "text-primary-500"
            : "text-orange-700";
        const iconColor =
          cell.origin.type === "connect"
            ? "text-primary-500"
            : "text-orange-700";

        return (
          <div className="flex items-center gap-2">
            <div
              className={`flex items-center justify-center rounded-full p-1 ${iconColor} ${bgColor}`}
            >
              <AtIcon
                size={20}
                name={
                  cell.origin.type === "connect"
                    ? "connect"
                    : "support-agent-filled"
                }
              />
            </div>
            <span className={`${baseClassName} ${textColor}`}>
              {cell.origin.name}
            </span>
          </div>
        );
      }
      case TableCellType.TEXT:
        return (
          <span className={`${baseClassName} !text-surface-400 break-all`}>
            {cell.value}
          </span>
        );

      case TableCellType.BUTTON: {
        const buttonCell = cell as ButtonCell;
        return (
          <AtButton
            text={buttonCell.value}
            buttonType={AtButtonType.TERTIARY}
            size={buttonCell.size || AtButtonSize.MEDIUM}
            onClick={buttonCell.onClick}
            disabled={buttonCell.disabled}
          />
        );
      }
      case TableCellType.BADGE: {
        const badgeCell = cell as BadgeCell;
        return <AtTag {...badgeCell.tagProps} />;
      }
    }
  };

  return (
    <TableCell
      align={cell.align || "left"}
      className={baseClassName}
      style={{ maxWidth: cell.maxWidth }}
    >
      {renderCellContent()}
    </TableCell>
  );
};
